import styled from 'styled-components';

export const HeaderWrapper = styled.div`
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #1f212b;
  color: gainsboro;
`;

export const AppTitle = styled.h1`
  padding: 0;
  margin: 0;
  font-size: 1.5rem;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
`;
